import React from "react";
import { InputRangeRow } from "./index";
// Used by Heli KV2008B and Heli KV2019B machines

export default function NoOfMaxStrokeRow() {
   return (
      <InputRangeRow
         titleProp={"No. of Max Stroke"}
         descriptionProp={""}
         sizeProp={6}
         colSizeProp={6}
         typeProp={"text"}
         minProp={1.0}
         maxProp={100.0}
         propertyNameProp={"maxStrokeCount"}
         errorDialogueProp={"1.0-100.0 only"}
         floatProp={true}
      />
   );
}
